import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auctions-tab"
}
const _hoisted_2 = ["onClick", "data-rel"]
const _hoisted_3 = {
  class: "error-content",
  "data-lang": "de"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "Jetzt auch Live!", -1)
const _hoisted_5 = {
  class: "error-content",
  "data-lang": "en"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, "Now also Live!", -1)

import { ref, PropType } from 'vue';
import { Auction } from '@/types/metadata';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionsTabs',
  props: {
  activeTab: {
    type: Number,
    default: 1,
  },
  lang: {
    type: String,
    default: 'en',
  },
  auctions: {
    type: Array as PropType<Auction[]>,
    default: () => [],
  },
},
  emits: ['update:activeTab'],
  setup(__props, { emit }) {

const props = __props;





const setActiveTab = (tabNumber: number) => {
  emit('update:activeTab', tabNumber);
};

return (_ctx: any,_cache: any) => {
  return (__props.auctions.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.auctions, (auction, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (setActiveTab(index + 1)),
            class: _normalizeClass([{ 'active': __props.activeTab === index + 1 }, "auction-tab"]),
            "data-rel": index + 1
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("h2", null, _toDisplayString(auction.title.de), 1)
            ], 512), [
              [_vShow, __props.lang === 'de']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("h2", null, _toDisplayString(auction.title.en), 1)
            ], 512), [
              [_vShow, __props.lang === 'en']
            ])
          ], 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})